import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { ClosingMessage } from '../components/ClosingMessage';
import { Welcome } from '../components/Welcome';
import { Schedule } from '../components/Schedule';
import { Location } from '../components/Location';
import { RSVPForm } from '../components/RSVPForm';
import { Footer } from '../components/Footer';
import { LockIcon } from 'lucide-react';
const PASSWORD = 'kanfamily';
export function Reunion() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === PASSWORD) {
      setIsUnlocked(true);
      setError(false);
    } else {
      setError(true);
    }
  };
  if (!isUnlocked) {
    return <div className="min-h-screen bg-paper flex items-center justify-center px-6" data-id="element-156">
        <form onSubmit={handleSubmit} className="w-full max-w-sm text-center space-y-6" data-id="element-157">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-terracotta/10 text-terracotta mb-2" data-id="element-158">
            <LockIcon className="w-6 h-6" data-id="element-159" />
          </div>
          <h2 className="text-3xl text-ink" data-id="element-160">Enter Password</h2>
          <p className="text-ink-light text-sm" data-id="element-161">
            This page is for family members only.
          </p>
          <input type="password" value={password} onChange={e => {
          setPassword(e.target.value);
          setError(false);
        }} placeholder="Password" className="w-full px-4 py-3 bg-paper-alt border border-ink/10 rounded-sm focus:outline-none focus:ring-2 focus:ring-terracotta/50 focus:border-terracotta transition-colors text-center text-lg" autoFocus data-id="element-162" />
          {error && <p className="text-sm text-red-500" data-id="element-163">
              Incorrect password. Please try again.
            </p>}
          <button type="submit" className="w-full bg-terracotta text-white py-3 rounded-sm text-lg transition-all hover:bg-[#A85D45]" data-id="element-164">
            Enter
          </button>
        </form>
      </div>;
  }
  return <div className="min-h-screen bg-paper font-serif text-ink selection:bg-terracotta/20 selection:text-terracotta" data-id="element-165">
      <Hero data-id="element-166" />
      <ClosingMessage data-id="element-167" />
      <Welcome data-id="element-168" />
      <Schedule data-id="element-169" />
      <Location data-id="element-170" />
      <RSVPForm data-id="element-171" />
      <Footer data-id="element-172" />
    </div>;
}